<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import {
  AreaChart,
  Banknote,
  Building2,
  Code,
  FileText,
  HandCoins,
  IterationCcw,
  Settings,
  Store,
  UserRound,
  UsersRound,
} from 'lucide-vue-next'
import NavbarItem from 'pejer/src/components/Navbar/NavbarItem.vue'

import { cn } from 'pejer/src/lib/utils'

import { usePejer } from '@/Pejer'
import NavbarSubItem from 'pejer/src/components/Navbar/NavbarSubItem.vue'
import { abbreviate } from 'pejer/src/utils'

const store = usePejer()
const props = defineProps<{ class?: String }>()
</script>

<template>
  <nav
    :class="
      cn(
        'w-[--sidebar-closed-width] xl:w-[--sidebar-width] bg-slate-100 border-r border-slate-200 flex flex-col flex-shrink-0 fixed',
        props.class
      )
    "
  >
    <div class="flex justify-center items-center gap-4 w-full text-secondaryBlack text-2xl my-4">
      <div class="w-5/6 flex justify-center items-center p-1 rounded-md">
        <div
          class="flex justify-center text-primaryBlue sentry-mask"
          v-if="store.state.platformInfo.value"
        >
          <h1 class="p-6 text-xl font-semibold text-center">
            <span class="xl:block hidden">
              <!-- {{ store.state.platformInfo.value.company }} -->
              <span class="text-md font-semibold">
                {{ store.state.platformInfo.value.brandName }}</span
              >
            </span>
            <span class="xl:hidden block">{{
              abbreviate(store.state.platformInfo.value.brandName)
            }}</span>
          </h1>
        </div>
      </div>
    </div>
    <div class="h-full">
      <NavbarItem to="/" text="Dashboard">
        <AreaChart class="shrink-0" :size="20" />
      </NavbarItem>
      <NavbarItem to="/payments" text="Payments">
        <Banknote :size="20" />
      </NavbarItem>
      <NavbarSubItem to="/kidTransactions" text="KID transactions">
        <FileText :size="18" />
      </NavbarSubItem>
      <NavbarSubItem to="/refunds" text="Refunds">
        <IterationCcw class="shrink-0" :size="16" />
      </NavbarSubItem>
      <NavbarItem to="/customers" text="Customers">
        <UserRound :size="20" />
      </NavbarItem>
      <NavbarItem to="/payouts" text="Payouts">
        <HandCoins :size="20" />
      </NavbarItem>
      <NavbarItem to="/accounts" text="Accounts">
        <Store :size="20" />
      </NavbarItem>
      <NavbarItem to="/businesses" text="Businesses">
        <Building2 class="shrink-0" :size="18" />
      </NavbarItem>
    </div>
    <div>
      <NavbarItem to="/users" text="Users">
        <UsersRound :size="20" />
      </NavbarItem>
      <NavbarItem to="/developer" text="Developer">
        <Code :size="20" />
      </NavbarItem>
      <NavbarItem to="/settings" text="Settings">
        <Settings :size="20" />
      </NavbarItem>
    </div>
  </nav>
</template>

<style scoped></style>
